/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useQuery, gql } from '@apollo/client';
export const useConfiguration = (key, skipApi=false) => {
    const variables = {
        inputKeys: key
      };
  const GET_CONFIGURATION  = gql`
  query Configuration($inputKeys: [String!]!) {
    configuration(inputKeys: $inputKeys) {
      name
      value
    }
  }
`;
  const { loading, error, data } = useQuery(GET_CONFIGURATION , { variables, skip: skipApi, fetchPolicy:'network-only', context:{clientName:"config"}
}, 
  );
  return { error, loading, data: data?.configuration ?? [] };
};
